<template>
    <Account
        :me="me"
        :password-min-length="passwordMinLength"
        :active-tab="activeTab"
        :is-client="hasClientRole"
        @updateMe="updateMe"
    />
</template>
<script>
import Account from "./_components/Account.vue";
import { store, getters, mutations } from "src/global-store.js";
import api from "src/services/api.js";

export default {
    name: "AccountModule",
    components: {
        Account,
    },
    beforeRouteUpdate(to, from, next) {
        if (to.meta.activeTab && to.path) {
            this.activeTab = to.path;
        }

        mutations.setNavbarTitle("Account");
        next();
    },
    data() {
        return {
            activeTab: "",
            passwordMinLength: 6,
        };
    },
    computed: {
        me() {
            return store.me;
        },
        hasClientRole() {
            return getters.hasClientRole();
        },
        isCustomer() {
            return getters.isCustomer();
        },
        isDesigner() {
            return getters.isDesigner();
        },
    },
    async created() {
        mutations.setNavbarTitle("Account");
        if (this.$route.meta.activeTab) {
            this.activeTab = this.$route.path || "";
        }
    },

    methods: {
        async updateMe(update) {
            try {
                await api.patch("/me", update);
                this.me.first_name = update.first_name;
                this.me.last_name = update.last_name;
            } catch (error) {
                console.error(error);
            }
        },
    },
};
</script>
